<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的日志</b>
        <div class="tips">
          <span>
            当月日志：<i class="uc-blue">{{
              this.logCalendar.current_month_count
            }}</i>
          </span>
          <span>
            师傅已评：<i class="uc-blue">{{
              this.logCalendar.current_month_evaluation_count
            }}</i>
          </span>
          <span>
            <el-tag type="danger" size="small">✔️</el-tag> 未评论
            <el-tag size="small">✔️</el-tag> 已评论
          </span>
        </div>
      </div>
      <el-button-group>
        <el-button icon="el-icon-plus" @click="dialogLogVisible = true"
          >写日志</el-button
        >
        <el-button @click="more"
          >more<i class="el-icon-arrow-right el-icon--right"></i
        ></el-button>
      </el-button-group>
    </div>

    <section class="uc-userCenterTitconstab3 bg-white">
      <el-calendar v-model="currentDate">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{ date, data }">
          {{
            data.day
              .split('-')
              .slice(1)
              .join('-')
          }}
          <div v-for="(item, index) in logCalendar.items" :key="index">
            <div v-if="item.create_time.indexOf(data.day) != -1">
              <el-tag v-if="item.is_evaluation > 0" size="small">✔️</el-tag>
              <el-tag v-else type="danger" size="small">✔️</el-tag>
            </div>
          </div>
        </template>
      </el-calendar>
    </section>

    <el-dialog
      title="日志"
      :visible.sync="dialogLogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item
          label="日期"
          prop="create_time"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="form.create_time"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
          <el-input v-model.trim="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            v-model.trim="form.content"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancle">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApprenticeLog',
  data() {
    return {
      query: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      currentDate: new Date(),
      logCalendar: {},
      dialogLogVisible: false,
      pickerOptions: {
        disabledDate: (time) => {
          const now = Date.now();
          const seven = 7 * 24 * 60 * 60 * 1000;
          const sevenDays = now - seven;
          return time.getTime() > now || time.getTime() < sevenDays;
        },
      },
      form: {
        id: 0,
        title: '',
        content: '',
        create_time: '',
      },
      rules: {
        create_time: [
          { required: true, message: '请选择日期', trigger: 'blur' },
        ],
        title: [{ required: true, message: '请输入日志标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入日志内容', trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();

    this.$nextTick(() => {
      // 点击前一个月
      const prevBtn = document.querySelector(
        '.el-calendar__button-group .el-button-group>button:nth-child(1)'
      );
      prevBtn.addEventListener('click', (e) => {
        this.query.year = this.currentDate.getFullYear();
        this.query.month = this.currentDate.getMonth() + 1;
        this.getShituLogCalendar();
      });
      // 点击下一个月
      const nextBtn = document.querySelector(
        '.el-calendar__button-group .el-button-group>button:nth-child(3)'
      );
      nextBtn.addEventListener('click', (e) => {
        this.query.year = this.currentDate.getFullYear();
        this.query.month = this.currentDate.getMonth() + 1;
        this.getShituLogCalendar();
      });
      // 点击今天
      const todayBtn = document.querySelector(
        '.el-calendar__button-group .el-button-group>button:nth-child(2)'
      );
      todayBtn.addEventListener('click', (e) => {
        this.query.year = this.currentDate.getFullYear();
        this.query.month = this.currentDate.getMonth() + 1;
        this.getShituLogCalendar();
      });
    });
  },
  methods: {
    initData() {
      this.getShituLogCalendar();
    },
    async getShituLogCalendar() {
      const response = await this.$api.shitu.getShituLogCalendar(this.query);
      this.logCalendar = response.data.data;
    },
    more() {
      // this.$router.push("/cart")
      // 传递的参数用{{ $route.query.goodsId }}获取
      this.$router.push({ name: 'ShituApprenticeLogList' });
    },
    // 提交数据
    handleSubmitSure() {
      const submitData = {
        id: this.form.id,
        title: this.form.title,
        content: this.form.content,
        create_time: this.form.create_time,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.editShituLog(submitData);
        }
      });
    },
    async editShituLog(myLog) {
      const response = await this.$api.shitu.editShituLog(myLog);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogLogVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    handleCancle() {
      this.dialogLogVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
  },
};
</script>
